<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
    تعریف کالا
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <mat-tab-group dynamicHeight (selectedTabChange)="onTabChange($event)" [selectedIndex]="type_task - 1">
            <mat-tab label="تعریف کالا">
                <div class="row pe" style="margin-top: 1rem;">
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="group" class='wh-label'>
                            <span> گروه </span>
                            <span (click)="add_group()" class="add_icon" [hidden]="readonly == true">
                                <mat-icon class="add-icon fleft">
                                    add </mat-icon>
                            </span>
                            <span (click)="reset_input(223)" [hidden]="readonly == true">
                                <mat-icon class="close" class="input_search input_search_pe">close</mat-icon>
                            </span>
                            <input class="wh-input" formControlName="group_title" (click)="load_services(223) "
                                [required]="required()" readonly [attr.disabled]="readonly">
                            <input class="wh-input" formControlName="group" [hidden]="true" [required]="required()"
                                readonly [attr.disabled]="readonly">
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="cate" class=' wh-label'>
                            <span> زیرگروه </span>
                            <span (click)="add_cate()" class="add_icon" [hidden]="readonly == true">
                                <mat-icon class="add-icon fleft">
                                    add </mat-icon>
                            </span>
                            <span (click)="reset_input(184)" [hidden]="readonly == true">
                                <mat-icon class="close" class="input_search input_search_pe">
                                    close</mat-icon>
                            </span>
                            <input class="wh-input" formControlName="cate_title" (click)="load_services(184) "
                                [required]="required()" readonly [attr.disabled]="readonly">
                            <input class="wh-input" formControlName="cate" [hidden]="true" [required]="required()"
                                readonly [attr.disabled]="readonly">
                        </label>
                    </div>

                    <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                        <label for="title" class='wh-label'>
                            <span> عنوان کالا </span>
                            <input class='wh-input' formControlName="title" autocomplete="off" [required]="required()"
                                [attr.disabled]="readonly">
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="weight" class='wh-label'>
                            <span> واحد اندازه گیری </span>
                            <span (click)="reset_input(211)" [hidden]="readonly == true">
                                <mat-icon class="close" class="input_search input_search_pe">close</mat-icon>
                            </span>
                            <input class="wh-input" formControlName="weight_title" (click)="load_services(211) "
                                readonly [attr.disabled]="readonly" [required]="required()">
                            <input class="wh-input" formControlName="weight" [hidden]="true" readonly
                                [attr.disabled]="readonly" [required]="required()">
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="coding" class='wh-label'>
                            <span> کد کالا </span>
                            <input class='wh-input' formControlName="coding" autocomplete="off"
                                [attr.disabled]="readonly">
                        </label>
                    </div>

                    <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pe div_panding'>
                        <label for="status_id" class='wh-label'>
                            <span> توضیحات </span>
                            <textarea style="height: 5rem;" class="wh-input" formControlName="comment"
                                [attr.disabled]="readonly">
                        </textarea>
                        </label>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="اطلاعات قیمت و موجودی کل" *ngIf="type_task == 2">
                <div class="row width100 pe" [hidden]="loading2" style="margin-top: 2rem;">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 fright div_panding">
                        <label for="last_price_buy" class='wh-label'>
                            <span class="fleft" (click)="get_cardex_buy()">
                                <i class="fas fa-info-circle icon icon-info"></i>
                            </span>
                            <span> آخرین قیمت خرید و تاریخ بروزرسانی</span>
                            <div class="div1">
                                <span> {{ last_price_buy | number }} </span>
                                <span> {{ currency_title }} </span>
                                <span class="fleft">{{ last_date_buy || '-' }}</span>
                            </div>
                        </label>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 fright div_panding">
                        <label for="last_price_sale" class='wh-label'>
                            <span class="fleft" (click)="get_cardex_sale()">
                                <i class="fas fa-info-circle icon icon-info"></i>
                            </span>
                            <span> آخرین قیمت فروش و تاریخ بروزرسانی</span>
                            <div class="div1">
                                <span> {{ last_price_sale | number }} </span>
                                <span> {{ currency_title }} </span>
                                <span class="fleft">{{ last_date_sale || '-' }}</span>
                            </div>
                        </label>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 fright div_panding">
                        <label for="material_remain" class='wh-label'>
                            <span> موجودی کل </span>
                            <div class="div1">
                                <span> {{ material_remain | number }} </span>
                                <span> {{ weight_title }} </span>
                            </div>
                        </label>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 fright div_panding">
                        <label for="title" class='wh-label'>
                            <span> عنوان کالا </span>
                            <div class="div1">
                                <span> {{ form1_group.get('title').value }} </span>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="center" style="margin-top: 1rem;" [hidden]="!loading2">
                    <div class="spinner-border spinner-border-sm" role="status">
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="موجودی اول دوره">
                <div class="row pe" style="margin-top: 1rem;">
                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="inventory" class='wh-label'>
                            <span> تعداد موجودی اول دوره : </span>
                            <input class='wh-input' formControlName="inventory" autocomplete="off"
                                [required]="required()" [attr.disabled]="readonly">
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="price" class='wh-label'>
                            <span> قیمت خرید اول دوره </span>
                            <input class='wh-input' formControlName="price" autocomplete="off" [required]="required()"
                                currencyMask [attr.disabled]="readonly">
                        </label>
                    </div>

                    <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pe div_panding'>
                        <label for="title" class='wh-label'>
                            <span> قیمت فروش </span>
                            <input class='wh-input' formControlName="price2" autocomplete="off" [required]="required()"
                                currencyMask [attr.disabled]="readonly">
                        </label>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div mat-dialog-actions class="matDialogActions" *ngIf="readonly != true">
        <button type="submit" [disabled]="!form1_group.valid || loading" class="btn_pe">
            <span>ذخیره</span>
        </button>
    </div>
</form>